import { Component, OnInit,Output,EventEmitter } from '@angular/core';
import { Route, Router } from '@angular/router';
import { UserService } from '../../shared/user.service';
import swal from 'sweetalert2';

@Component({
  selector: 'app-level1menu',
  templateUrl: './level1menu.component.html',
  styleUrls: ['./level1menu.component.css']
})
export class Level1menuComponent implements OnInit {

  @Output() change = new EventEmitter();
  @Output() toparent:EventEmitter<string>=new EventEmitter<string>();
  menuList:any;
  selectedItem:any;
  data:any;
  BRANCH_ID: string;
  BRANCH_NAME: string;
  user:string;
  cmpdata: any;

  constructor(private router: Router,private userService: UserService) { }

  ngOnInit() {
    this.GetBranch()
    this.menuList=localStorage.getItem('menuList');
    this.menuList=JSON.parse(this.menuList);
    
    let selectedMenuId=localStorage.getItem('selectedMenu');
    if(selectedMenuId !=null && selectedMenuId != '' && typeof(selectedMenuId)!=undefined)
      this.selectedItem=selectedMenuId;
    else{
      if(this.menuList.length!=0)
        this.selectedItem=this.menuList[0].KM_MenuId;
    }  
    this.user=localStorage.getItem('userName');
    this.getcompanyid();
  }

  listClick(event, newValue) {
    localStorage.setItem('selectedMenu',newValue);
    this.selectedItem = newValue;  
}

GetBranch() {
  debugger
  document.getElementById('loader-spinner').style.display = "block";
  this.data = this.userService.GetBranch();
  this.data.subscribe(
    (data: any) => {
      localStorage.setItem('BRANCH_ID', data.BRANCH_ID);
      localStorage.setItem('BRANCH_NAME', data.BRANCH_NAME);
      localStorage.setItem('DB_BRANCH_ID', data.BranchMainId);
      this.BRANCH_ID=localStorage.getItem('BRANCH_ID');
      this.BRANCH_NAME=localStorage.getItem('BRANCH_NAME');
      this.toparent.emit(this.BRANCH_NAME);
      //this.Show = response;
      document.getElementById('loader-spinner').style.display = "none";
    }, (error) => {
      swal('', error.error.Message, 'warning');
      document.getElementById('loader-spinner').style.display = "none";
    });
}

  Logout(){
    localStorage.clear();
    this.change.emit(true);
    this.router.navigate(['/login']);
  }
  getcompanyid()
  {
    this.cmpdata=this.userService.getmastercompany();
    this.cmpdata.subscribe(
      (response:any)=>
      {
        localStorage.setItem('Cmp_Id', response.cmp_id);
        localStorage.setItem('Cmp_Name', response.cmp_name);
      }
    )
  }

}



// WEBPACK FOOTER //
// ./src/app/common/level1menu/level1menu.component.ts